export enum EmailDeliveryStatusCode {
    Unknown = 'Unknown',
    Queued = 'Queued',
    Delivered = 'Delivered',
    Failed = 'Failed',
    IncorrectEmailAddress = 'IncorrectEmailAddress',
    SendingLimitExceeded = 'SendingLimitExceeded'
}
